export const EventOnliner = function() {
  const onlinerList = new Map();
  this.addOnlieTimer = function(infoTimer, time, callBack) {
    let id = `${infoTimer.status}_${infoTimer.uid}`;
    if (onlinerList.has(id)) {
      return;
    }
    console.log('addOnlieTimer id:', id);
    infoTimer.Timer = setInterval(() => {
      let curOnlineInfo = onlinerList.get(id);
      if (!curOnlineInfo) {
        onlinerList.delete(id);
        clearInterval(infoTimer.Timer);
        curOnlineInfo.Timer = null;
        return;
      }
      
      callBack(curOnlineInfo);
    }, time);
    onlinerList.set(id, infoTimer);
  };
  this.changeInfoTime = function(infoTimer, time) {
    let id = `${infoTimer.status}_${infoTimer.uid}`;
    let curOnlineInfo = onlinerList.get(id);
    if (curOnlineInfo) {
      curOnlineInfo.time = time;
      curOnlineInfo.token = infoTimer.token;
      onlinerList.set(id, curOnlineInfo);
    }
  };
  this.clearTimer = function(infoTimer) {
    if (!infoTimer) return;
    let id = `${infoTimer.status}_${infoTimer.uid}`;
    this.clearTimerById(id);
  };
  this.clearTimerById = function(id) {
    let curOnlineInfo = onlinerList.get(id);
    if (!curOnlineInfo) return;

    if (curOnlineInfo.Timer) {
      clearInterval(curOnlineInfo.Timer);
      curOnlineInfo.Timer = null;
      // curOnlineInfo.time = 0;
    }
    onlinerList.delete(id);
    console.log('clearTimer id:', id);
  }
  this.clearTimerByStatusAndUid = function(status, uid) {
    let id = `${status}_${uid}`;
    this.clearTimerById(id);
  }
  this.clearAllTimer = function() {
    const timerIds = Array.from(onlinerList.keys());
    console.log('clearAllTimer timerIds:', timerIds);
    for (const id of timerIds) {
      this.clearTimerById(id);
    }
  }
  this.hasTimerById = function (id) {
    return onlinerList.has(id);
  }
};
